module.exports = __webpack_public_path__ + "static/baiyulan-993f7dad5310483efb7af6cb9ef54af8.jpg";